import VirtualDomElement from '../VirtualDomElement';

export default class DocumentPoint extends VirtualDomElement {
  constructor({ x, y, width, height, color, onRequestDraw = () => null }) {
    super(onRequestDraw);
    this.set('x', x);
    this.set('y', y);
    this.set('width', width);
    this.set('height', height);
    this.set('color', color);
  }

  draw(ctx, transform) {
    let [x_inner, y_inner] = transform.apply([this.get('x'), this.get('y')]);
    [x_inner, y_inner] = this.getFlooredCoordinates([x_inner, y_inner]);

    if (this.get('fill')) {
      ctx.fillStyle = this.get('color');

      ctx.fillRect(
        x_inner,
        y_inner,
        this.get('width') * transform.k,
        this.get('height') * transform.k,
      );
    } else {
      ctx.strokeStyle = this.get('color');
      ctx.rect(
        x_inner,
        y_inner,
        this.get('width') * transform.k,
        this.get('height') * transform.k,
      );
      ctx.stroke();
      ctx.beginPath();
    }
  }
}
